Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.designEditorCollectionHelpers = {
        initialize: function() {
            if (_.isTruthy(gon.previewMode)) {
                this.displayOptions = App.request('get:display:options');
                this.listenTo(this.displayOptions, {
                    'change:reviewOptions.lightboxReviews': this.refreshWidget,
                    'change:reviewOptions.frequency': this.refreshWidget,
                    'change:pageSize': this.refreshWidget,
                    'change:carouselOptions.smoothSwiping': this.refreshWidget,
                });
            }
        },
        refreshWidget: function(displayOptions) {
            // Reset Active Review ID's
            gon.activeReviewIds = [];
            // Close/Refresh lightbox
            this.closeLightbox();
            if (_.isArray(this.swiperQueue)) { // test this
                this.options.photosCollection.reset();
                this.updateSwipingMode(displayOptions.get('carouselOptions.smoothSwiping'));
            } else if (this.collectionQueue && this.collectionQueue !== this.collection) {
                // Refresh Mosaic V2 photo collection if exists
                this.collectionQueue.fetch({
                    reset: true
                });
            } else {
                // Refresh regular photo collection
                this.collection.fetch({
                    reset: true
                });
            }
        },
        closeLightbox: function() {
            var data = {
                name: 'pixlee:close:lightbox',
                type: 'action',
                source: 'lightbox',
                destination: 'all',
                data: {}
            };

            window.parent.postMessage(JSON.stringify(data), '*');
        }
    };

});